import { default as httpInstance } from '@/jmHttp/index';
import { activityNbi } from '@/jmHttp/interface';
/**
 * 活动牛币（每日签到 / 新手任务）相关 API
 */

/**
 * 查询当前用户各活动入口的可见性
 * @param {object} [data] - 入参，接口无需参数
 * @param {object} [config] - 额外的请求配置
 * @returns {Promise<object>} data: { signInEntry, newbieEntry, signInEntryUrl, newbieEntryUrl, newbieTaskRedDot }
 */
export const getActivityEntry = async (data = {}, config = {}) => {
  return await httpInstance.post(activityNbi.getActivityEntry, data, config);
};

/**
 * 新手任务面板：资格、聚合态、已获得/总奖励与任务列表
 * @param {object} [data] - 入参，接口无需参数
 * @param {object} [config] - 额外的请求配置
 * @returns {Promise<object>} data: { eligible, state, stateName, earnedReward, totalReward, tasks }
 */
export const getNewbieTaskPanel = async (data = {}, config = {}) => {
  return await httpInstance.post(activityNbi.getNewbieTaskPanel, data, config);
};

/**
 * 新手任务完成上报（后端幂等，重复上报 rewardNbi 为 0）
 * @param {{ bizType: number }} data - 入参，bizType 见 NEWBIE_TASK_BIZ_TYPE
 * @param {object} [config] - 额外的请求配置
 * @returns {Promise<object>} data: { completed, alreadyCompleted, rewardNbi, state, stateName, message }
 */
export const reportNewbieTaskComplete = async (data, config = {}) => {
  return await httpInstance.post(activityNbi.reportNewbieTaskComplete, data, config);
};

/**
 * 标记用户已查看新上线的新手任务，上报后 newbieTaskRedDot 转为 false
 * @param {object} [data] - 入参，接口无需参数
 * @param {object} [config] - 额外的请求配置
 * @returns {Promise<object>} 接口无业务返回
 */
export const reportNewbieTaskView = async (data = {}, config = {}) => {
  return await httpInstance.post(activityNbi.reportNewbieTaskView, data, config);
};

/**
 * 签到信息：今日是否已签、连续天数与签到奖励规则
 * @param {object} [data] - 入参，接口无需参数
 * @param {object} [config] - 额外的请求配置
 * @returns {Promise<object>} data: { signedToday, continuousDays, rewardNbi, cycleDays, dailyRewardNbi, cycleRewardNbi }
 */
export const getSignInInfo = async (data = {}, config = {}) => {
  return await httpInstance.post(activityNbi.getSignInInfo, data, config);
};

/**
 * 执行签到并发放牛币（后端幂等，今日已签也返回 signed = true）
 * @param {object} [data] - 入参，接口无需参数
 * @param {object} [config] - 额外的请求配置
 * @returns {Promise<object>} data: { signed, alreadySigned, continuousDays, rewardNbi, cycleReward, message }
 */
export const doSignIn = async (data = {}, config = {}) => {
  return await httpInstance.post(activityNbi.doSignIn, data, config);
};
